const SquareDown = ({
  width = 24,
  height = 24,
  fill = "currentColor",
  ...props
}) => (
  <svg
    {...props}
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
      fill={fill}
    />
    <path
      d="M11.9999 15.26C11.8099 15.26 11.6199 15.1899 11.4699 15.0399L8.46994 12.0399C8.17994 11.7499 8.17994 11.27 8.46994 10.98C8.75994 10.69 9.23994 10.69 9.52994 10.98L11.9999 13.45L14.4699 10.98C14.7599 10.69 15.2399 10.69 15.5299 10.98C15.8199 11.27 15.8199 11.7499 15.5299 12.0399L12.5299 15.0399C12.3799 15.1899 12.1899 15.26 11.9999 15.26Z"
      fill={fill}
    />
    <path
      d="M12 15.26C11.59 15.26 11.25 14.92 11.25 14.51V6.51001C11.25 6.10001 11.59 5.76001 12 5.76001C12.41 5.76001 12.75 6.10001 12.75 6.51001V14.51C12.75 14.93 12.41 15.26 12 15.26Z"
      fill={fill}
    />
    <path
      d="M11.9999 18.2302C9.88994 18.2302 7.76995 17.8902 5.75995 17.2202C5.36995 17.0902 5.15995 16.6602 5.28995 16.2702C5.41995 15.8802 5.83994 15.6602 6.23994 15.8002C9.95994 17.0402 14.0499 17.0402 17.7699 15.8002C18.1599 15.6702 18.5899 15.8802 18.7199 16.2702C18.8499 16.6602 18.6399 17.0902 18.2499 17.2202C16.2299 17.9002 14.1099 18.2302 11.9999 18.2302Z"
      fill={fill}
    />
  </svg>
);

export default SquareDown;
